module.exports = __webpack_public_path__ + "grandmaster-4107a345ad5b6211e33e.png";